import { api } from 'hooks/useApi';

export type LocationRaw = {
  // Country
  id: number;
  name: string;
  states: {
    // State/Province
    id: number;
    name: string;
    alpha: string; // Short name
    metropolitans: {
      id: string;
      code: string;
      counties: {
        id: string | null;
        name: string;
        cities: {
          id: number;
          name: string;
          code: string;
        }[];
      }[];
    }[];
  }[];
};

const getLocations = () => {
  return api.get<LocationRaw[]>('v2/locations/');
};

export default {
  getLocations,
};
